<template>
    <div id="cropper-modal" class="cropperModal">
        <div class="cropperModalContent">
            <div class="cropperModalHeader" ref="cropperModalHeader">
                <h2>
                    <slot name="title" />
                    <button id="cropper-modal-close" data-qa-id="modal-close-icon" class="cropperModalClose"
                        @click="closeCropperModal($event)">
                        <Close />
                    </button>
                </h2>
            </div>
            <div class="cropperModalBody" ref="cropperModalBody">
                <slot name="content" />
                <div class="cropperModalBodyAnimation" v-if="!imageSrc">
                    <AnimationProcessing fill="grey" class="pageSpinner" data-qa-id="loading-icon" />
                </div>
                <div class="cropperWrapper" v-else>
                    <cropper v-if="priority === 2" ref="cropper" class="cropper" :src="imageSrc" :auto-zoom="false"
                        :stencilSize="{
                        width: 1200,
                        height: 300,
                    }" 
                    :stencil-props="{
                        aspectRatio: 4 / 1,
                        handlers: {},
                        resizable: false,
                    }" 
                    background-class="cropperBackground"
                    image-class="cropperImage"
                    foreground-class="cropperForeground"
                    />
                    <cropper v-if="priority === 1" ref="cropper" class="cropper" :src="imageSrc" :auto-zoom="false"
                        :stencilSize="{
                            width: 256,
                            height: 256,
                        }" 
                        :stencil-props="{
                            aspectRatio: 1 / 1,
                            handlers: {},
                            resizable: false,
                        }" 
                        background-class="cropperBackground"
                        image-class="cropperImage"
                        foreground-class="cropperForeground"
                        />
                </div>
            </div>
            <div class="cropperModalFooter" ref="cropperModalFooter">
                <slot name="actions" />
                <MdButton id="cropper-modal-cancel" color="lightgrey" size="large" data-qa-id="modal-cancel-button" @click="closeCropperModal($event)">
                    {{ $t('buttons.cancel') }}
                </MdButton>
                <MdButton id="cropper-modal-confirm" size="large" data-qa-id="modal-image-button" @click="setImage($event)">
                    {{ $t('buttons.setimage') }}
                </MdButton>
            </div>
        </div>
    </div>
</template>